import {
  LOAD_DYNAMIC_SIDEBAR,
  REMOVE_LISTS,
  LOAD_DYNAMIC_SIDEBAR_DETAIL,
  CREATE_DYNAMIC_SIDEBAR,
  UPDATE_DYNAMIC_SIDEBAR,
  LOAD_DYNAMIC_SIDEBAR_MENU_HIERARCHY,
} from './actions'

const initialState = {
  dynamicSidebarData: [],
  total: 0,
  loading: false,

  detailLoading: false,
  dynamicSidebarDetail: {},

  count_group: {},

  actionLoading: false,

  dynamicSidebarMenuHierarchy: [],
  loadingMenuHierarchy: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState
    case LOAD_DYNAMIC_SIDEBAR.REQUEST:
      const { loading } = action.payload
      return {
        ...state,
        loading: loading,
        dynamicSidebarData: [],
        total: 0,
      }

    case LOAD_DYNAMIC_SIDEBAR.SUCCESS:
      const { lists, page } = action.payload
      let listData = lists.data || []
      //เพิ่ม rowNumber ให้กับแต่ละรายการ
      listData = listData.map((item, index) => ({
        ...item,
        rowNumber: (page - 1) * 10 + index + 1,
      }))

      return {
        ...state,
        loading: false,
        dynamicSidebarData: listData,
        total: lists.total || 0,
      }

    case LOAD_DYNAMIC_SIDEBAR_DETAIL.REQUEST:
      return {
        ...state,
        detailLoading: true,
        dynamicSidebarDetail: {},
      }
    case LOAD_DYNAMIC_SIDEBAR_DETAIL.SUCCESS:
      const { data } = action.payload
      return {
        ...state,
        detailLoading: false,
        dynamicSidebarDetail: data || {},
      }

    case CREATE_DYNAMIC_SIDEBAR.REQUEST:
      return {
        ...state,
        actionLoading: true,
      }
    case CREATE_DYNAMIC_SIDEBAR.SUCCESS:
      return {
        ...state,
        actionLoading: false,
      }
    case UPDATE_DYNAMIC_SIDEBAR.REQUEST:
      return {
        ...state,
        actionLoading: true,
      }
    case UPDATE_DYNAMIC_SIDEBAR.SUCCESS:
      return {
        ...state,
        actionLoading: false,
      }
    case LOAD_DYNAMIC_SIDEBAR_MENU_HIERARCHY.REQUEST:
      return {
        ...state,
        loadingMenuHierarchy: true,
        dynamicSidebarMenuHierarchy: [],
      }
    case LOAD_DYNAMIC_SIDEBAR_MENU_HIERARCHY.SUCCESS:
      return {
        ...state,
        loadingMenuHierarchy: false,
        dynamicSidebarMenuHierarchy:
          action.payload.data.data.isupplyDynamicSidebar || [],
      }

    default:
      return state
  }
}
